class PositionConstants {
  static CEO = 'CEO';
  static CFO = 'CFO';
  static FOUNDER = 'Founder';
  static HEAD_OF_COMMUNICATIONS = 'Head of Communications';
  static DEVELOPER = 'Developer';
  static ACADEMIC_LEAD = 'Academic Lead';
  static HEAD_OF_QUANT_CLUB = 'Head of Quant Club';
  static MEMBER = 'Member';

  static OPTIONS = [
    PositionConstants.CEO,
    PositionConstants.CFO,
    PositionConstants.FOUNDER,
    PositionConstants.HEAD_OF_COMMUNICATIONS,
    PositionConstants.DEVELOPER,
    PositionConstants.ACADEMIC_LEAD,
    PositionConstants.HEAD_OF_QUANT_CLUB,
    PositionConstants.MEMBER,
  ];
}

export default PositionConstants;